import script from "./IgnoreLongTimelongContinuousWarningUpdateModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./IgnoreLongTimelongContinuousWarningUpdateModal.vue?vue&type=script&setup=true&lang=ts"

import "./IgnoreLongTimelongContinuousWarningUpdateModal.vue?vue&type=style&index=0&id=139b69f7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-139b69f7"]])

export default __exports__